const latlng = require("./latlng");

module.exports = latlng;
